var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.isActive,"z-index":1000}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":64}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }